import { render, staticRenderFns } from "./ConfiguracoesMultipleNumbers.vue?vue&type=template&id=4e0ed714"
import script from "./ConfiguracoesMultipleNumbers.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesMultipleNumbers.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesMultipleNumbers.vue?vue&type=style&index=0&id=4e0ed714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports